import React, { useState } from 'react';
import './AboutUs.css';

const AboutUs = () => {
    // Estado para manejar si la imagen principal falla al cargar
    const [imgError, setImgError] = useState(false);

    return (
        <section className="nosotros" id="nosotros">
            <div className="container">
                {/* --- ARRIBA: FOTO EQUIPO + TEXTO --- */}
                <div className="nosotros-top">
                    <div className="rv">
                        <div className="nosotros-img-wrap">
                            {!imgError ? (
                                <img
                                    src="/assets/nosotros.webp"
                                    alt="Equipo NAVI"
                                    onError={() => setImgError(true)}
                                />
                            ) : (
                                <div className="nsFallback">
                                    <img src="/assets/logo-sin-fondo.webp" alt="NAVI" style={{ height: '52px', opacity: 0.2 }} />
                                    <span>Equipo NAVI</span>
                                </div>
                            )}
                            <div className="nosotros-img-caption">
                                <p>"Convertir la IA en soluciones reales, accesibles e innovadoras"</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="eyebrow rv">Quiénes somos</div>
                        <h2 className="s-title rv d1">Un equipo con<br />experiencia real</h2>

                        {/* He conservado tu texto original fusionado con el nuevo */}
                        <p className="nosotros-body rv d2">
                            En Navi ayudamos a pequeñas y medianas empresas a digitalizarse mediante soluciones de
                            automatización con inteligencia artificial. Optimizamos procesos clave como la logística, la
                            organización interna y la atención al cliente, haciendo que el día a día sea más eficiente.
                            <br /><br />
                            Somos un equipo interdisciplinario formado por expertos en logística, ingeniería industrial,
                            diseño de procesos e inteligencia artificial. Entendemos los problemas desde adentro — y los
                            resolvemos con tecnología que funciona en la realidad.
                        </p>

                        <a
                            href="https://www.navitechlabs.com/nosotros"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nosotros-link rv d3"
                        >
                            Conocer al equipo completo
                            <svg width="16" height="16" viewBox="0 0 14 14" fill="none">
                                <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                    </div>
                </div>

                {/* --- ABAJO: TARJETAS DEL EQUIPO --- */}
                <div className="team-title rv">El equipo fundador</div>
                <div className="team-grid">
                    <div className="team-card rv">
                        <div className="team-card-photo" style={{ background: 'linear-gradient(135deg,#07091A,#1022C8)' }}>
                            <img className="team-card-photo-img" src="/assets/juanma_miembro.jpg" alt="Juan Manuel Zambrano" />
                            <div className="team-card-initials">JM</div>
                        </div>
                        <div className="team-card-body">
                            <div className="team-card-name">Juan Manuel Zambrano</div>
                            <div className="team-card-role">CEO & Co-Fundador</div>
                            <div className="team-card-area">Diseñador Industrial · M. en Ingeniería de Organización y Logística</div>
                            <div className="team-card-quote">"Mi misión es convertir la visión en estrategia y la IA en soluciones reales, accesibles e innovadoras que generen impacto positivo."</div>
                        </div>
                    </div>

                    <div className="team-card rv d1">
                        <div className="team-card-photo" style={{ background: 'linear-gradient(135deg,#0A17A0,#1730D8)' }}>
                            <img className="team-card-photo-img" src="/assets/jd_miembro.jpg" alt="Juan Diego Espinosa" />
                            <div className="team-card-initials">JD</div>
                        </div>
                        <div className="team-card-body">
                            <div className="team-card-name">Juan Diego Espinosa</div>
                            <div className="team-card-role">COO & Co-Fundador</div>
                            <div className="team-card-area">Ing. Mecánico · M. en Ingeniería de Organización y Logística</div>
                            <div className="team-card-quote">"Mi propósito es transformar la complejidad en soluciones simples que permitan a las empresas hacer más con menos."</div>
                        </div>
                    </div>

                    <div className="team-card rv d2">
                        <div className="team-card-photo" style={{ background: 'linear-gradient(135deg,#050816,#1022C8)' }}>
                            <img className="team-card-photo-img" src="/assets/franco_miembro.jpeg" alt="Franco Stefano Giner" />
                            <div className="team-card-initials">FS</div>
                        </div>
                        <div className="team-card-body">
                            <div className="team-card-name">Franco Stefano Giner Vásquez</div>
                            <div className="team-card-role">CTO</div>
                            <div className="team-card-area">Ing. Informático · Arquitectura de IA y Sistemas</div>
                            <div className="team-card-quote">"Mi objetivo es volver realidad cada idea con ayuda de la tecnología, evolucionando con esta industria en constante cambio."</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;